import { InterpolationPrimitive } from '@emotion/serialize'
import React, { DOMAttributes, ReactNode } from 'react'
import { StyledLinkProps } from 'utils/styled'
import {
  SContainer,
  SMainContent,
  SStickyMobileHeader,
  SSideContent,
  SStaticDesktopHeader,
} from './SideLayout.styled'

export const SideLayout = React.forwardRef<
  HTMLDivElement,
  {
    header?: ReactNode
    left?: ReactNode
    right?: ReactNode
    leftCss?: InterpolationPrimitive
    rightCss?: InterpolationPrimitive
    className?: string
  } & StyledLinkProps &
    DOMAttributes<HTMLDivElement>
>(({ header, left, right, leftCss, rightCss, as, children, className, ...restProps }, ref) => {
  return (
    <div>
      <SStickyMobileHeader>{header}</SStickyMobileHeader>
      <SContainer className={className} as={as} {...restProps}>
        {left && <SSideContent css={leftCss}>{left}</SSideContent>}
        <SMainContent ref={ref}>
          <SStaticDesktopHeader>{header}</SStaticDesktopHeader>
          {children}
        </SMainContent>
        {right && <SSideContent css={rightCss}>{right}</SSideContent>}
      </SContainer>
    </div>
  )
})
SideLayout.displayName = 'SideLayout'
